import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'snake_case' })
export class SnakeCasePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(title) {
    return title.toLowerCase().replace(/\s/g, '_').replace(/\//g, '_');
  }
}
